var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":JSON.parse(_vm.$route.params.sales) ? 'Bon de livraison' : 'Livraison',"verbose-name-plural":JSON.parse(_vm.$route.params.sales) ? 'Bons de livraison' : 'Livraisons',"ressource":"delivery-notes","add":false,"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }